module.exports = __webpack_public_path__ + "static/media/1.08d5f2b9.jpg";